import { render, staticRenderFns } from "./MarketSingle.vue?vue&type=template&id=4e851c70&scoped=true&"
import script from "./MarketSingle.vue?vue&type=script&lang=js&"
export * from "./MarketSingle.vue?vue&type=script&lang=js&"
import style0 from "./MarketSingle.vue?vue&type=style&index=0&id=4e851c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e851c70",
  null
  
)

export default component.exports